import type { CurrencySettingsType } from "./types";

export const currencyConfig: Record<string, CurrencySettingsType> = {
  USD: {
    wantsFewerPackages: true,
    shippingAccountNumber: true,
    proformaInvoice: true,
    invoicePDF: true,
    availableShippingMethods: ["Carrier", "Special"],
    availablePaymentMethods: ["CreditCard", "NetTerms", "Quote"],
    billingDataAreaId: "THO",
  },
  JPY: {
    wantsFewerPackages: true,
    shippingAccountNumber: false,
    proformaInvoice: false,
    invoicePDF: false,
    availableShippingMethods: ["Special"],
    availablePaymentMethods: ["Quote"],
  },
  CNY: {
    wantsFewerPackages: false,
    shippingAccountNumber: false,
    proformaInvoice: true,
    invoicePDF: false,
    availableShippingMethods: ["Special"],
    availablePaymentMethods: ["Quote"],
  },
  BRL: {
    wantsFewerPackages: true,
    shippingAccountNumber: false,
    proformaInvoice: true,
    invoicePDF: true,
    availableShippingMethods: ["Special"],
    availablePaymentMethods: ["NetTerms", "Quote"],
  },
  SEK: {
    wantsFewerPackages: true,
    shippingAccountNumber: true,
    proformaInvoice: true,
    invoicePDF: true,
    availableShippingMethods: ["Carrier", "Special"],
    availablePaymentMethods: ["NetTerms", "Quote"],
  },
  GBP: {
    wantsFewerPackages: true,
    shippingAccountNumber: true,
    proformaInvoice: true,
    invoicePDF: true,
    availableShippingMethods: ["Carrier", "Special"],
    availablePaymentMethods: ["CreditCard", "NetTerms", "Quote"],
    billingDataAreaId: "UK0",
  },
  EUR: {
    wantsFewerPackages: true,
    shippingAccountNumber: true,
    proformaInvoice: true,
    invoicePDF: true,
    availableShippingMethods: ["Carrier", "Special"],
    availablePaymentMethods: ["CreditCard", "NetTerms", "Quote"],
    billingDataAreaId: "EUR",
  },
  INR: {
    wantsFewerPackages: true,
    shippingAccountNumber: false,
    proformaInvoice: true,
    invoicePDF: true,
    availableShippingMethods: ["Carrier", "Special"],
    availablePaymentMethods: ["NetTerms", "Quote"],
  },
};
